<script setup lang="ts">
import { FlagChip, useBreakpoints } from '@collector/shared-ui'
import { Participant } from '@collector/sportsapi-client-legacy'

interface Props {
  participant: Participant
  chips: (boolean | null)[]
  reversed?: boolean
}
defineProps<Props>()

const { breakpoints } = useBreakpoints()
</script>

<template>
  <div
    class="@2md:gap-4 flex flex-col gap-1"
    :class="{
      'items-start': !reversed,
      'items-end': reversed,
    }"
  >
    <div
      class="w-full overflow-hidden text-nowrap text-ellipsis"
      :class="{
        'text-right': reversed,
      }"
    >
      {{ participant.short_name }}
    </div>
    <div
      class="@2md:gap-y-6 grid grid-cols-5 justify-items-center gap-x-3 gap-y-1"
      :dir="reversed ? 'rtl' : undefined"
    >
      <FlagChip
        v-for="(penaltyChip, index) in chips"
        :key="index"
        :size="
          breakpoints['2md'].value
            ? 'sm'
            : breakpoints['md'].value
              ? 'xs'
              : '2xs'
        "
        variant="fill-border"
        :modelValue="!!penaltyChip"
        :indeterminate="penaltyChip === null"
      />
    </div>
  </div>
</template>
